import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions-in-production',
  template: `
    <div class="sip-card">
      <div class="sip-head">
        <span class="sip-title">Solutions in Production</span>
      </div>
      <div class="prodlist">
        <div
          class="prod-row"
          *ngFor="let solution of solutionsInProduction; let i = index"
        >
          <span class="prod-ic">
            <svg
              viewBox="0 0 24 24"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="4" width="18" height="13" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
          </span>
          <span class="prod-nm">
            {{
              solution.length > 32 ? solution.substr(0, 29) + '...' : solution
            }}</span
          >
          <span class="st-pill st-live">In production</span>
        </div>
        <div class="empty" *ngIf="solutionsInProduction.length === 0">
          No solutions in production yet.
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./solutions-in-production.component.scss'],
})
export class SolutionsInProductionComponent implements OnInit {
  solutionsInProduction = [
    'Solution1',
    'Solution2',
    'Solution3',
    'Solution1',
    'Solution2',
    'Solution3',
  ];


  ngOnInit(): void {
    this.solutionsInProduction = this.solutionsInProduction.slice(0, 3);
  }
}
